import instance from '../axios.config';

const getApiKey = async () => {
  const data = instance.get('/merchant/apikey');
  return data;
};

export { getApiKey };
